export const PRESENCE_GET_WEEK = 'PRESENCE_GET_WEEK'
export const PRESENCE_SET_DAY = 'PRESENCE_SET_DAY'
